import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'
import { statusIsQuote } from 'Cube/domain/postActionStages/queries/availableFeatures/utils/availableFeatures.constants'
import { PermissionString, usePermissions } from 'lib/rbac'

export const usePhasePermissions = () => {
  const context = useCubeContext()
  const { can } = usePermissions()
  const isQuote = statusIsQuote(context.queries.rawData.data.common.status)

  const phaseCreatePermission: PermissionString = isQuote
    ? 'org.quote:create'
    : 'org.billing:create'
  const phaseUpdatePermission: PermissionString = isQuote
    ? 'org.quote:update'
    : 'org.billing:update'

  return {
    phaseUpdatePermission,
    phaseCreatePermission,
    canUpdatePhase: can(phaseUpdatePermission)
  }
}
